import { render, staticRenderFns } from "./Isabella.vue?vue&type=template&id=623673f4&scoped=true"
import script from "./Isabella.vue?vue&type=script&lang=js"
export * from "./Isabella.vue?vue&type=script&lang=js"
import style0 from "./Isabella.vue?vue&type=style&index=0&id=623673f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623673f4",
  null
  
)

export default component.exports